module.exports = __webpack_public_path__ + "img/integration-placeholder.1ef76c6a.svg";